export default "__VITE_ASSET__xcKclBsi__"